import { FlexBox } from '@airship-platform/jam-web/components';
import {
  CheckmarkIcon,
  DownloadIcon,
  RetryIcon,
} from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

export type DocumentRowProps = {
  name: string;
  statusMessage?: string;
  status: 'ready' | 'generating' | 'pending' | 'not-available';
  generatedAt?: string;
  url?: string;
  isGenerating?: boolean;
  onGenerate?: () => Promise<unknown>;
};

const DocumentRow: React.FC<DocumentRowProps> = ({
  name,
  statusMessage,
  status,
  generatedAt,
  url,
  isGenerating,
  onGenerate,
}) => {
  const displayStatus = isGenerating ? 'generating' : status;

  return (
    <FlexBox flexDirection="column">
      <FlexBox justifyContent="space-between" alignItems="center" py={1.5}>
        <FlexBox flexDirection="column" gap={0.5}>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            {name}
          </Typography>
          <FlexBox alignItems="center" gap={0.5}>
            {displayStatus === 'ready' && (
              <>
                <CheckmarkIcon color={'green'} />
                {generatedAt && (
                  <Typography variant="caption" color="text.secondary">
                    Ready &bull; Generated on {generatedAt}
                  </Typography>
                )}
              </>
            )}
            {(displayStatus === 'generating' ||
              displayStatus === 'pending') && (
              <FlexBox flexDirection="column">
                <FlexBox>
                  <RetryIcon color={'grey'} />
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ textTransform: 'capitalize' }}
                  >
                    {displayStatus}
                  </Typography>
                </FlexBox>
                <Typography variant="caption" color="text.secondary">
                  {statusMessage || 'Generating, please wait'}
                </Typography>
              </FlexBox>
            )}
            {displayStatus === 'not-available' && (
              <Typography variant="caption" color="text.secondary">
                {statusMessage || 'Not available'}
              </Typography>
            )}
          </FlexBox>
        </FlexBox>
        {displayStatus === 'ready' && url && (
          <Button
            size="small"
            color="softGold"
            startIcon={<DownloadIcon width={16} height={16} />}
            href={url}
          >
            Download
          </Button>
        )}
        {displayStatus !== 'ready' && (
          <Button
            size="small"
            color="softGold"
            startIcon={<RetryIcon width={16} height={16} />}
            onClick={onGenerate}
            disabled={
              displayStatus === 'generating' || displayStatus === 'pending'
            }
          >
            Generate
          </Button>
        )}
      </FlexBox>
      <Divider />
    </FlexBox>
  );
};

export default DocumentRow;
